// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1yx-w","rootSuccess":"CompleteLink_rootSuccess__R1hbi","rootFailure":"CompleteLink_rootFailure__339TI","isDisabled":"CompleteLink_isDisabled__16Ry1"};